@if (isLoading()) {
  <app-loader></app-loader>
} @else {
  <app-items-supply-chain-documents-table
    [nameForTableFilenameExport]="nameForTableFilenameExport()"
    [documents]="documents"
    [columns]="columns"
  ></app-items-supply-chain-documents-table>
}
